import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import createHelpers from './createHelpers';
import createLogger from './logger';
// import { SESSION_LOGOUT_SUCCESS } from '../constants';

export default function configureStore(initialState, helpersConfig) {
  const helpers = createHelpers(helpersConfig);
  const middleware = [thunk.withExtraArgument(helpers)];

  let enhancer;

  if (__DEV__) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    let devToolsExtension = (f) => f;
    if (process.env.BROWSER && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__();
    }

    enhancer = compose(applyMiddleware(...middleware), devToolsExtension);
  } else {
    enhancer = applyMiddleware(...middleware);
  }
  /*
  const rootReducer = (state, action) => {
    if (action.type === SESSION_LOGOUT_SUCCESS) {
      // eslint-disable-next-line no-param-reassign
      state = undefined;
    }
    return appReducer(state, action);
  };
*/
  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const store = createStore(rootReducer, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept('../reducers', () =>
      // eslint-disable-next-line global-require
      store.replaceReducer(require('../reducers').default),
    );
  }

  return store;
}
